import { useQueryClient } from '@tanstack/react-query';
import { useRef, useCallback } from 'react';
import { useGetStudentsInClassesQuery, getStudentsInClassesQuery } from '@pm2/api';
import { useNavigationManager } from '@provider/navigation';
import { useUserIdentityState } from '@provider/user-identity';
import { prefetchQueryIfNeeded } from '@utils/common';
import { ShareSelect } from './atom.select.js';
import { jsx } from 'react/jsx-runtime';

function StudentsPage(props) {
  const fallbackStudents = useRef(props.selectedStudents);
  const queryClient = useQueryClient();
  const navigation = useNavigationManager();
  const user = useUserIdentityState(state => state.user);
  const students = useGetStudentsInClassesQuery(props.selectedClasses.map(it => it.id));
  const selectedValues = props.selectedStudents.map(it => ({
    id: it.id,
    label: it.name
  }));
  const options = students.data?.map(student => ({
    id: student.id,
    label: student.name
  })) ?? [];
  const toggleValue = useCallback(id => {
    const toggledStudent = students.data?.find(it => it.id === id);
    if (!toggledStudent) {
      return;
    }
    props.setSelectedStudents(prev => {
      const set = new Set(prev);
      if (set.has(toggledStudent)) {
        set.delete(toggledStudent);
      } else {
        set.add(toggledStudent);
      }
      return [...set];
    });
  }, [props, students.data]);
  const handleCancel = useCallback(() => {
    props.setSelectedStudents(fallbackStudents.current);
    navigation.push("/");
  }, [navigation, props]);
  const handleSave = useCallback(async () => {
    await prefetchQueryIfNeeded(queryClient, getStudentsInClassesQuery(user, props.selectedClasses.map(it => it.id)));
    navigation.push("/");
  }, [navigation, props.selectedClasses, queryClient, user]);
  return /*#__PURE__*/jsx(ShareSelect, {
    requiredLabel: "V\xE6lg de elever du vil dele versionen med",
    label: "V\xE6lg elev",
    inputPlaceholder: "S\xF8g efter elev",
    selectedValues: selectedValues.map(it => it.id),
    options: options,
    toggleValue: toggleValue,
    onSave: handleSave,
    onCancel: handleCancel
  });
}

export { StudentsPage };
//# sourceMappingURL=page.students.js.map
